import { api } from '@/core/helpers/axiosHelper';

export default {
   async postBulk(body: any) {
      return await api.post('/tag-type/tag-bulk', body, { params: { include: 'tags' } }).then((response) => {
         return response.data;
      });
   },
   async patch(tag_type_id: number, body: { op: string; path: string; value: any }) {
      return await api.patch('/tag-type/' + tag_type_id, [body]).then((response) => {
         return response.data;
      });
   },
   async putBulk(tag_type_id: number, body: any) {
      return await api.put('/tag-type/' + tag_type_id + '/tag-bulk', body, { params: { include: 'tags' } }).then((response) => {
         return response.data;
      });
   },
   async delete(tag_type_id: number) {
      return await api.delete('/tag-type/' + tag_type_id).then((response) => {
         return response.data;
      });
   },
};
